import { render, staticRenderFns } from "./OogList.vue?vue&type=template&id=2f03072c&scoped=true"
import script from "./OogList.vue?vue&type=script&lang=js"
export * from "./OogList.vue?vue&type=script&lang=js"
import style0 from "./OogList.vue?vue&type=style&index=0&id=2f03072c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03072c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f03072c')) {
      api.createRecord('2f03072c', component.options)
    } else {
      api.reload('2f03072c', component.options)
    }
    module.hot.accept("./OogList.vue?vue&type=template&id=2f03072c&scoped=true", function () {
      api.rerender('2f03072c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/OogList.vue"
export default component.exports